<div class="row">
<div class="col-sm-3 order-sm-4">
  <div style="height:25.3em!important;">
    <app-director-card-img [directorship]="directorship" [scale]="1.3"></app-director-card-img>
  </div>
  <span class="badge text-bg-primary me-2" *ngFor="let directorTag of director.tags">{{directorTag.tag.name}}</span>
</div>
<div class="col-sm-9 order-sm-4">
  <div class="row mb-3">
    <div class="col-sm-9 order-sm-4">
      <h6 class="pb-2 text-body-tertiary">DIRECTOR</h6>
      <h1>{{[director.firstname,director.middlenames,director.lastname] | joinArray}}</h1>
      <p class="mb-1"><span class="text-body-tertiary">Gender: </span>
        <span class="fw-bold">{{director.gender}}</span>
      </p>
      <p class="mb-1"><span class="text-body-tertiary">Age: </span>
        <span class="fw-bold">{{director.age | number}}</span>
      </p>
      <p class="mb-1"><span class="text-body-tertiary">Education: </span>
        <span class="fw-bold">{{director.education}}</span>
      </p>
      <p class="mb-1"><span class="text-body-tertiary">Realized Compensation: </span>
        <span class="fw-bold">{{director.total_compensation | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
      </p>
      <p><span class="text-body-tertiary">Boards: </span>
        <span class="fw-bold">{{director.boards}}</span>
      </p>

      <button type="button" ngbAutofocus class="btn btn-outline-primary">
        Follow
      </button>
      <button class="btn rounded-0" type="button">
        <i class="bi bi-printer"></i>
      </button>
      <button class="btn rounded-0" type="button">
        <i class="bi bi-download"></i>
      </button>
    </div>
    <div class="col-sm-3 order-sm-4">
      <div class="circle bg-primary">
        <p>Director<br>Batting Average<i class="bi bi-question-circle ps-1" [matTooltip]="methodology.tsr" #tt_tsr="matTooltip" (click)="tt_tsr.toggle()"></i><br>
          <span class="display-1">{{director.influenced_network_score | number : '1.3-3'}}</span></p>
      </div>
    </div>
  </div>
  <div class="row mb-1">
    <div class="col-12">
      <p class="small mb-0 text-end">Most recent data as of: {{director.updated_at | date}}</p>
    </div>
  </div>
  <div class="row ps-0 pe-0">
    <div class="col-sm-12 order-sm-4 ps-0 pe-0 modal-table-container">
      <table
        mat-table
        [dataSource]="groupDirectorStats(director.stats)"
        class="table table-hover rounded rounded-3"
        multiTemplateDataRows>
        <ng-container matColumnDef="year" sticky>
          <th mat-header-cell *matHeaderCellDef style="min-width: 6rem!important;">Year</th>
          <td mat-cell *matCellDef="let stat">
            <span>{{stat.year}}</span>
          </td></ng-container
        >

        <ng-container matColumnDef="influence">
          <th mat-header-cell *matHeaderCellDef>
            <div class="d-flex flex-row align-items-center">
              AVE TOTAL<br>INFLUENCE
              <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.average_total_influence" #tt_average_total_influence="matTooltip" (click)="tt_average_total_influence.toggle()"></i>
            </div>
          </th>
          <td mat-cell *matCellDef="let stat">
            <span>{{stat.average_influence / 100 | percent}}</span>
          </td></ng-container
        >

        <ng-container matColumnDef="ebitda">
          <th mat-header-cell *matHeaderCellDef>
            <div class="d-flex flex-row align-items-center">
              EBITDA
              <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.ebitda" #tt_ebitda="matTooltip" (click)="tt_ebitda.toggle()"></i>
            </div>
          </th>
          <td mat-cell *matCellDef="let stat">
            <span>{{stat.career_ebitda | number : '1.3-3'}}</span>
          </td></ng-container
        >
        <ng-container matColumnDef="carbon">
          <th mat-header-cell *matHeaderCellDef>
            <div class="d-flex flex-row align-items-center">
              CARBON<br>INTENSITY
              <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.carbon_intensity" #tt_carbon_intensity="matTooltip" (click)="tt_carbon_intensity.toggle()"></i>
            </div>
          </th>
          <td mat-cell *matCellDef="let stat">
            <span>{{stat.career_carbon | number : '1.3-3' }}</span>
          </td></ng-container
        >

        <ng-container matColumnDef="tsr">
          <th mat-header-cell *matHeaderCellDef>
            <div class="d-flex flex-row align-items-center">
              TSR
              <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.tsr" #tt_tsr="matTooltip" (click)="tt_tsr.toggle()"></i>
            </div>
          </th>
          <td mat-cell *matCellDef="let stat">
            <span>{{stat.career_tsr | number : '1.3-3'}}</span>
          </td></ng-container
        >

        <ng-container matColumnDef="controversies">
          <th mat-header-cell *matHeaderCellDef>
            <div class="d-flex flex-row align-items-center">
              CONTROVERSIES
              <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.controversies" #tt_controversies="matTooltip" (click)="tt_controversies.toggle()"></i>
            </div></th>
          <td mat-cell *matCellDef="let stat">
            <span>{{stat.career_contr | number : '1.3-3'}}</span>
          </td></ng-container>

        <ng-container matColumnDef="is_expanded" stickyEnd>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let stat">
            <ng-container *ngIf="isExpandable(stat, director)">

              <ng-container
                *ngIf="expandedSelection.isSelected(stat); else showMinimiseBtn">
                <i class="bi bi-caret-up-fill"></i>
              </ng-container>
              <ng-template #showMinimiseBtn>
                <i class="bi bi-caret-down-fill"></i>
              </ng-template>
            </ng-container>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let stat; columns: displayedColumns"
          [class.example-expanded-row]="expandedSelection.isSelected(stat)"
          (click)="expandedSelection.toggle(stat)"
          class="directorship-row"
          [cdkDetailRow]="stat"
          [cdkDetailRowTpl]="tpl"></tr>
      </table>

      <ng-template #tpl let-rootStat>
        <tr class="expandable-row" *ngFor="let stat of director.stats  | callback: filterStatsOther: rootStat.year">
          <td>
            <a [routerLink]="['/company', stat.company.id, stat.company.issuer_name]" (click)="viewCompany(stat.company)" class="company-logo">
              <app-company-logo [company]="stat.company" [showTitle]="true"></app-company-logo>
            </a>
          </td>
          <ng-container *ngIf="subscription || !stat.is_premium else blurred">
            <td><span>{{stat.career_influence / 100 | percent}}</span></td>
            <td><span>{{stat.company_ebitda | number : '1.3-3' }}</span></td>
            <td><span>{{stat.company_carbon | number : '1.3-3' }}</span></td>
            <td><span>{{stat.company_tsr  | number : '1.3-3'}}</span></td>
            <td><span>{{stat.company_contr  | number : '1.3-3'}}</span></td>
          </ng-container>
          <ng-template #blurred>
            <td class="blurred"><span>{{0 | percent}}</span></td>
            <td class="blurred"><span>{{0 | number : '1.3-3' }}</span></td>
            <td class="blurred"><span>{{0 | number : '1.3-3' }}</span></td>
            <td class="blurred"><span>{{0 | number : '1.3-3'}}</span></td>
            <td class="blurred"><span>{{0 | number : '1.3-3'}}</span></td>
          </ng-template>
          <td ></td>
        </tr>
      </ng-template>
    </div>
  </div>
</div>
</div>
